var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('hero-section'),_c('home-section2'),_c('home-section1'),_c('home-section9'),_c('home-section10'),_c('home-section11'),_c('home-section4'),_c('section6'),_c('section4'),_c('ready-to-work'),_c('footer-home')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }